import { render, staticRenderFns } from "./PunchsPage.vue?vue&type=template&id=cc8e6e1e&scoped=true"
import script from "./PunchsPage.vue?vue&type=script&lang=js"
export * from "./PunchsPage.vue?vue&type=script&lang=js"
import style0 from "./PunchsPage.vue?vue&type=style&index=0&id=cc8e6e1e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8e6e1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc8e6e1e')) {
      api.createRecord('cc8e6e1e', component.options)
    } else {
      api.reload('cc8e6e1e', component.options)
    }
    module.hot.accept("./PunchsPage.vue?vue&type=template&id=cc8e6e1e&scoped=true", function () {
      api.rerender('cc8e6e1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/attendances/punchs/PunchsPage.vue"
export default component.exports